<
<template>
	<TheTable
		v-if="tableData"
		:tableData="tableData"
		:loading="loading"
		:defaultSort="{ prop: 'createdDate', order: 'descending' }"
		:showMaxRows="14"
		@rowClick="goToDetailPage"
		@rowClickNewTab="goToDetailPageNewTab"
		:mobileBox="mobileBox"
	>
		<template #box>
			<BoxCasePublic v-for="item in tableData" :key="item.id" :item="item" />
		</template>

		<el-table-column prop="publishedDate" label="Datum" width="130" sortable>
			<template #default="scope">
				<span>{{ $formatDate(scope.row.publishedDate) }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="title" label="Titel" min-width="250" sortable :sort-method="(a, b) => $sortAlphabetically(a, b, 'title')" />
		<el-table-column prop="mediums" label="Medium" width="200" sortable>
			<template #default="scope">
				<span v-if="scope.row.mediums">{{ scope.row.mediums.map((medium) => medium.name).join(', ') }}</span>
				<span v-else>-</span>
			</template>
		</el-table-column>

		<el-table-column prop="category" label="Beschwerdegrund" width="200" sortable>
			<template #default="scope">
				<span v-if="scope.row.category">{{ $recursivelyFindCategoryName(scope.row.category.number) }}</span>
				<span v-else>-</span>
			</template>
		</el-table-column>
	</TheTable>

	<TablePagination :currentLength="tableData.length" :totalMaxVal="totalCount" @loadNextPage="$emit('loadNextPage')" />
</template>

<script lang="ts">
import { Paperclip } from '@element-plus/icons-vue';
import { defineComponent, PropType } from 'vue';
import { CaseAndComplaintPublicResponse, CasePublicResponse } from '../../types/types';
import TheTable from '../TheTable.vue';
import TablePagination from './TablePagination.vue';
import BoxCasePublic from '../boxes/BoxCasePublic.vue';

export default defineComponent({
	name: 'PublicCasesTable',
	data() {
		return {};
	},
	props: {
		tableData: {
			type: Array as PropType<CaseAndComplaintPublicResponse[]>,
			default: [],
			required: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		totalCount: {
			type: Number,
			default: 0,
		},
		mobileBox: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		Paperclip,
		TheTable,
		TablePagination,
		BoxCasePublic,
	},
	emits: ['loadNextPage'],
	methods: {
		goToDetailPage(row) {
			if (row.isCase) {
				this.$router.push({ name: 'FallDetail', params: { id: String(row.id) } });
			} else {
				this.$router.push({ name: 'BeschwerdeDetail', params: { id: String(row.id) } });
			}
		},
		goToDetailPageNewTab(row) {
			if (row.isCase) {
				window.open(this.$router.resolve({ name: 'FallDetail', params: { id: String(row.id) } }).href, '_blank');
			} else {
				window.open(this.$router.resolve({ name: 'BeschwerdeDetail', params: { id: String(row.id) } }).href, '_blank');
			}
		},
	},
});
</script>

<style lang="scss"></style>
